// Libraries
import clsx from "clsx";
import { HTMLAttributes } from "react";
import { Box, SxProps, Theme, Typography } from "@mui/material";

type TNoResultAddAnywayProps = {
	sx?: SxProps<Theme>;
	title?: string;
	linkText?: string;
	disabled: boolean;
	onLinkClick?: () => void;
} & HTMLAttributes<HTMLDivElement>;

export default function NoResultAddAnyway(props: Readonly<TNoResultAddAnywayProps>) {
	const { title = "", sx = {}, linkText, disabled, onLinkClick } = props;

	return (
		<Box
			className={clsx({
				"w-full h-full !justify-center text-center !inline-flex": true,
			})}
			sx={sx}
		>
			<Typography className="!font-montserrat !text-[12px] text-gray-text font-medium !my-auto">
				{title ?? "No rows"}
				{linkText ? "," : ""}
			</Typography>

			{linkText && (
				<Typography
					className={clsx({
						"!font-montserrat !text-[12px] font-medium !my-auto !ml-1 underline cursor-pointer": true,
						"text-primary": !disabled,
						"text-disabled": disabled,
						"cursor-not-allowed": disabled,
					})}
					onClick={onLinkClick}
				>
					{linkText}
				</Typography>
			)}
		</Box>
	);
}
